import { User } from '../../models/User';
import { IUserState } from '../../interfaces/IUser';

const userStore = ({
    namespaced: true,
    name: 'userstate',
    state: {
        User: new User(),
        AdminCookie : "",
    } as IUserState,
    getters: {
        getUser(state: IUserState) {
            return state.User;
        },
        getAdminCookie(state: IUserState) {
            return state.AdminCookie;
        },
    },
    mutations: {
        putUser(state : IUserState, user : User) {
            state.User = user;
        },
        putAdminCookie(state : IUserState, cookie : string) {
            state.AdminCookie = cookie;
        },
    },
    actions: {
        setUser(context : any, user : User) {
            context.commit('putUser', user);
        },
        setAdminCookie(context : any, cookie : string) {
            context.commit('putAdminCookie', cookie);
        },
    },
})

export default userStore;
